<div class="bai-filter-chip-group" role="group" [attr.aria-label]="ariaLabel()">
  @for (option of options(); track trackById($index, option)) {
    <button
      type="button"
      class="bai-filter-chip"
      [class.bai-filter-chip--active]="isSelected(option.id)"
      [disabled]="option.disabled ?? false"
      [attr.aria-pressed]="isSelected(option.id)"
      [attr.aria-label]="option.ariaLabel ?? option.label"
      (click)="onSelect(option.id)"
    >
      {{ option.label }}
    </button>
  }
</div>
